import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Card.css";

const Card = ({ children, className, onMouseEnter, onMouseLeave }) => (
  <div
    className={cx(styles.card, className)}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </div>
);

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default Card;
